import React from 'react';
import {
  DashboardShell,
  StatCards,
  SimpleBarChart,
  DataTable,
  formatPoints,
} from './DashboardShared';

const FinanceTemplate = ({ data }) => {
  const cards = data.cards || {};

  return (
    <DashboardShell
      title={`${data.company.name} — Finance`}
      subtitle="Points liability and distribution control"
      data={data}
    >
      <StatCards
        items={[
          {
            label: data.company.is_mother_company ? 'Wallet liability (pts)' : 'Points credited',
            value: formatPoints(
              data.company.is_mother_company ? cards.wallet_liability : cards.points_credited
            ),
          },
          {
            label: 'BDT equivalent',
            value: cards.bdt_equivalent != null ? `৳${formatPoints(cards.bdt_equivalent)}` : '—',
          },
          { label: 'Points issued (month)', value: formatPoints(cards.points_this_month) },
          {
            label: 'Exchange rate',
            value: cards.bdt_per_point != null ? `৳${cards.bdt_per_point} / pt` : '—',
          },
        ]}
      />

      {data.monthly_chart?.length > 0 && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Monthly points issued</h2>
          <SimpleBarChart data={data.monthly_chart} />
        </section>
      )}

      {data.product_mix_chart?.length > 0 && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Sales by product</h2>
          <SimpleBarChart data={data.product_mix_chart} />
        </section>
      )}

      <DataTable
        title="Points by company (this month)"
        columns={[
          { key: 'company_name', label: 'Company' },
          {
            key: 'points',
            label: 'Points',
            render: (row) => formatPoints(row.points),
          },
        ]}
        rows={data.commissions_by_company || []}
      />

      <DataTable
        title="Recent distributions"
        columns={[
          { key: 'date', label: 'Date', render: (row) => (row.date ? String(row.date).split(' ')[0] : '—') },
          { key: 'company_name', label: 'Company' },
          { key: 'product_name', label: 'Product' },
          { key: 'service_name', label: 'Sale type' },
          { key: 'seller_name', label: 'Sold by', render: (row) => row.seller_name ?? '—' },
          {
            key: 'total_points',
            label: 'Total pts',
            render: (row) => formatPoints(row.total_points),
          },
        ]}
        rows={data.recent_distributions || []}
      />
    </DashboardShell>
  );
};

export default FinanceTemplate;
